import React from "react";

import LanguageSelection from "./LanguageSelection";


function TopNavigation(props) {
  
  const {values} = props;
  const { isParmEmbassyCode,selectedEmbassyCode } = values;

  return (
    <div className="top-section py-4">
      <div className="container-xxl always-ltr">
        <div className="row">
          {isParmEmbassyCode &&  <div className="col-6">            
            <a href={(selectedEmbassyCode.toLowerCase())}><img src="images/emx-logo.svg" alt="Emirates Post" className="main-logo" /></a>
          </div>}
          {!isParmEmbassyCode &&  <div className="col-6">            
            <a href="/embassy"><img src="images/emx-logo.svg" alt="Emirates Post" className="main-logo" /></a>
          </div>}
          <div className="col-6  align-self-center always-right">
            <LanguageSelection {...props}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopNavigation;
